import React from 'react';
import { BlockScreen } from '../BlockScreen';
import { ConfirmationScreen } from '../ConfirmationScreen';
import { Notification } from '../SecondaryScreen/Notification';
export var SecondaryScreen = function SecondaryScreen(_ref) {
  var loginBlockState = _ref.loginBlockState,
      twoFactorDetails = _ref.twoFactorDetails,
      dictionary = _ref.dictionary,
      token = _ref.token,
      notification = _ref.notification,
      handleLoginFailure = _ref.handleLoginFailure,
      handleLoginSuccess = _ref.handleLoginSuccess,
      setTwoFactorDetails = _ref.setTwoFactorDetails,
      setLoginBlockState = _ref.setLoginBlockState,
      isDesktop = _ref.isDesktop;

  if (loginBlockState) {
    return /*#__PURE__*/React.createElement(BlockScreen, {
      dictionary: dictionary,
      isDesktop: isDesktop,
      loginBlockState: loginBlockState,
      setLoginBlockState: setLoginBlockState,
      setTwoFactorDetails: setTwoFactorDetails,
      token: token
    });
  }

  if (twoFactorDetails) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Notification, {
      notification: notification
    }), /*#__PURE__*/React.createElement(ConfirmationScreen, {
      dictionary: dictionary,
      handleLoginFailure: handleLoginFailure,
      handleLoginSuccess: handleLoginSuccess,
      isDesktop: isDesktop,
      setTwoFactorDetails: setTwoFactorDetails,
      token: token,
      twoFactorDetails: twoFactorDetails
    }));
  }

  return null;
};